import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=124dfbe9&scoped=true&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=124dfbe9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124dfbe9",
  null
  
)

export default component.exports